var map = {
	"./close-alert.svg": "8181",
	"./close-error.svg": "113d",
	"./close-info.svg": "a87d",
	"./close-success.svg": "5a38",
	"./error.svg": "76e2",
	"./info.svg": "727f",
	"./success.svg": "1cc8",
	"./warning.svg": "8484"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3df";